<template>
  <basic-container>
    <avue-crud :option="option" :table-loading="loading" :data="data" :page.sync="page" :permission="permissionList"
      :before-open="beforeOpen" v-model="form" ref="crud" @row-update="rowUpdate" @row-save="rowSave" @row-del="rowDel"
      @search-change="searchChange" @search-reset="searchReset" @selection-change="selectionChange"
      @current-change="currentChange" @size-change="sizeChange" @refresh-change="refreshChange" @on-load="onLoad">
      <template slot="menuLeft">
        <el-button type="danger" size="small" icon="el-icon-delete" plain v-if="permission.stathistory_delete"
          @click="handleDelete">删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getList, getDetail, add, update, remove } from "@/api/stat/stathistory";
import { mapGetters } from "vuex";
import { getLazyTree } from "@/api/base/region";
export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        dialogClickModal: false,
        column: [
          {
            label: "区划名称",
            prop: "regionName",
            hide: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
          },
          {
            label: "区划编码",
            prop: "regionNameCode",
            type: "cascader",
            hide: true,
            addDisabled: false,
            dicUrl: `/api/blade-system/region/lazy-tree?parentCode=00`,
            props: {
              label: "title"
            },
            // emitPath: false,
            checkStrictly: true,
            showAllLevels: false,
            lazy: true,
            viewDisplay: false,
            filterable: true,
            lazyLoad: (node, resolve) => {

              let list = [];
              let stop_level = 4;
              let level = node.level || 0;
              let callback = () => {
                resolve((list || []).map(ele => {
                  // console.log(ele)
                  return Object.assign(ele, {
                    leaf: level >= stop_level
                  })
                }));
              }
              const parentCode = (level === 0) ? "00" : node.data.id;

              getLazyTree(parentCode).then(res => {
                list = res.data.data;
                callback()
              })
            },
            formatter: (row, value, label, column) => {
              return row.regionCode;
            },
            change: ({ value }) => {
              if(value==""){
                return;
              }
              console.log("value",value)
              var _this = this;
              let valuedata = "";
              let valuedataList = []
              if (Array.isArray(value)) {
                console.log("数组")
                valuedataList = value;
              } else {
                console.log("非数组")
                valuedata = value;
                valuedataList = valuedata.split(",");
              }
              this.form.regionCode = valuedataList[valuedataList.length - 1];
                getLazyTree(valuedataList.length>=2?valuedataList[valuedataList.length-2]:'00').then(res => {
                  for(var key in res.data.data){
                    if(res.data.data[key].value == _this.form.regionCode){
                      _this.form.regionName =  res.data.data[key].title;
                      _this.form.regionNameCode = valuedataList.join();
                      console.log("form",_this.form)
                      break;
                    }
                  }
                })
            },
            rules: [{
              required: true,
              message: "请选择行政区划",
              trigger: "blur"
            }]
          },
          {
            label: "区划编码",
            prop: "regionCode",
            addDisabled: true,
            editDisabled: true,
            rules: [{
              required: true,
              message: "请输入行政区划编码",
              trigger: "blur"
            }]
          },
          // {
          //   label: "行政区划",
          //   prop: "regionName",
          //   rules: [{
          //     required: true,
          //     message: "请输入行政区划",
          //     trigger: "blur"
          //   }]
          // },
          {
            label: "年份",
            prop: "year",
            type: "year",
            rules: [{
              required: true,
              message: "请选择年份",
              trigger: "blur"
            }]
          },
          {
            label: "总犯罪嫌疑人数",
            prop: "amount",
            change: ({ value }) => {
              if (this.form.underageNumber != "" && value != "") {
                let returnValue = this.form.underageNumber / value * 100;
                this.form.underagePercent = returnValue.toFixed(2) + "%";

              }
              if (this.form.adultNumber != "" && value != "") {
                let returnValue2 = this.form.adultNumber / value * 100;
                this.form.adultPercent = returnValue2.toFixed(2) + "%";
              }
            },
            rules: [{
              required: true,
              message: "请输入总犯罪嫌疑人数",
              trigger: "blur"
            }]
          },
          {
            label: "未成年犯罪嫌疑人人数",
            prop: "underageNumber",
            change: ({ value }) => {
              if (value != "" && this.form.amount != "") {
                let returnValue = value / this.form.amount * 100;
                this.form.underagePercent = returnValue.toFixed(2) + "%";
              }
            },
            rules: [{
              required: true,
              message: "请输入未成年犯罪嫌疑人人数",
              trigger: "blur"
            }]
          },
          {
            label: "未成年犯罪嫌疑人占比",
            prop: "underagePercent",
            addDisabled: true,
            editDisabled: true,
            rules: [{
              required: true,
              message: "请输入未成年犯罪嫌疑人占比",
              trigger: "blur"
            }]
          },
          {
            label: "18-25岁青少犯罪嫌疑人人数",
            prop: "adultNumber",
            change: ({ value }) => {
              if (value != "" && this.form.amount != "") {
                let returnValue = value / this.form.amount * 100;
                this.form.adultPercent = returnValue.toFixed(2) + "%";
              }
            },
            rules: [{
              required: true,
              message: "请输入18-25岁青少犯罪嫌疑人人数",
              trigger: "blur"
            }]
          },
          {
            label: "25岁以下青少犯罪嫌疑人占比",
            prop: "adultPercent",
            addDisabled: true,
            editDisabled: true,
            rules: [{
              required: true,
              message: "请输入25岁以下青少犯罪嫌疑人占比",
              trigger: "blur"
            }]
          },
        ]
      },
      data: []
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.stathistory_add, false),
        viewBtn: this.vaildData(this.permission.stathistory_view, false),
        delBtn: this.vaildData(this.permission.stathistory_delete, false),
        editBtn: this.vaildData(this.permission.stathistory_edit, false)
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  },
  methods: {
    rowSave(row, done, loading) {
      row.year = row.year.getFullYear();
      add(row).then(() => {
        this.onLoad(this.page);
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        done();
      }, error => {
        loading();
        window.console.log(error);
      });
    },
    rowUpdate(row, index, done, loading) {
      if (typeof (row.year) != 'string') {
        row.year = row.year.getFullYear();
      }
      update(row).then(() => {
        this.onLoad(this.page);
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        done();
      }, error => {
        loading();
        console.log(error);
      });
    },
    rowDel(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (["edit", "view"].includes(type)) {
        getDetail(this.form.id).then(res => {
          this.form = res.data.data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page, params = {}) {
      this.loading = true;
      getList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(res => {
        const data = res.data.data;
        this.page.total = data.total;
        this.data = data.records;
        console.log("数据", data.records[0]);
        this.loading = false;
        this.selectionClear();
      });
    }
  }
};
</script>

<style>

</style>
